import React, { useEffect, useState } from "react";
import "./Objectives.css";
import { Button, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Success_Toster from "../../../../../../common/common_modal/success_toster/Success_Toster";
function Objectives({handleClose}) {

  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <>
      <section className="Imperiality Quality_Policy Objectives">
        <div className="back_div">
          <Common_Back_Btn backText="Quality Policy" />
        </div>

        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              Our company is committed to maintaining the highest standards of
              accuracy, reliability, and integrity in all laboratory operations.
              We ensure continuous improvement of our processes, compliance with
              quality standards, and customer satisfaction through effective
              documentation and controlled file management — including secure
              addition and deletion of files as per QMS guidelines.
            </p>
          </div>

          {/* File Section */}
          <div className="file_section">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-9">
                    <Form.Group className="form_group file_field">
                      <div className="image_holder">
                        <img
                          className="img_preview"
                          src="/assets/images/objectives/img_1.png"
                          alt="preview"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  <div className="col-md-3">
                    <Form.Group className="form_group file_field">
                      <div className="image_holder">
                        <img
                          className="img_preview"
                          src="/assets/images/objectives/img_2.png"
                          alt="preview"
                        />
                      </div>
                    </Form.Group>
                  </div>

                  <div className="col-md-12 ">
                    <Form.Group className="form_group file_field">
                      <Form.Control
                        value="Type Objectives..."
                        as="textarea"
                        rows={8}
                        disabled
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-12">
                    <Form.Group className="form_group file_field">
                      <div className="image_holder">
                        <img
                          className="img_preview"
                          src="/assets/images/objectives/img_2.png"
                          alt="preview"
                        />
                      </div>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Upload / Delete Button */}
         
          <div className="permission_btn_holder">
          {!success ? (
            <>
              <Button
                type="button"
                className="permission_btn No_btn"
              >
                Generete PDF
              </Button>

              <Button
                type="submit"
                className="permission_btn Yes_btn"
                onClick={() => {
                  setSuccess(true);
                }}
              >
                Save Objectives
              </Button>
            </>
          ) : (
            <Success_Toster successText={"Save Objectives Successfully!"} />
          )}
        </div>
        </div>
      </section>
    </>
  );
}

export default Objectives;
